<template>
<div>
  <b-nav tabs align="center">
    <b-nav-item v-for="account_id in listBalanceAccounts()" v-bind:key="account_id"
                :active="$store.getters.currentAccount == account_id" @click="selectAccount($event, account_id)">
      {{account_id}}
    </b-nav-item>
  </b-nav>

  <b-table striped hover :items="balance_items" :fields="balance_fields" @row-clicked="_showBalance"></b-table>

  <b-modal hide-footer ref="balance-detail" :title="'Детализация баланса: '+getPeriod()">
     <b-table striped hover :items="$store.state.charges" :fields="charge_fields"></b-table>
     <b-table striped hover :items="$store.state.payments" :fields="pay_fields"></b-table>
  </b-modal>

</div>
</template>

<script>
export default {
  name: "BalanceView",
  data() {
      return {
        balance_items: [],
        balance_fields: [
          {key: 'period_id', label: 'Период', sortable: false},
          {key: 'balance_out', label: 'Баланс', sortable: false},
          {key: 'charge', label: 'Начисления', sortable: false},
          {key: 'payment', label: 'Оплаты', sortable: false},
          {key: 'document_id', label: 'Счет', sortable: false}
        ],
        charge_fields: [
          {key: 'service_name', label: 'Позиция'},
          {key: 'final_amount', label: 'Сумма'},
          // {key: 'service_date', label: 'Начисленно'},
        ],
        pay_fields: [
          {key: 'amount', label: 'Сумма'},
          {key: 'pay_date', label: 'Оплачено'},
          {key: 'confirm_date', label: 'Зачисленно'},
        ],
      }
    },
  methods: {
    _showBalance: function(item){
      this.$store.dispatch('getCharges', {'account_id': item['account_id'], 'period_id': item['period_id']})
      this.$store.dispatch('getPayments', {'account_id': item['account_id'], 'period_id': item['period_id']})
      this.showModal();
    },
    showModal() {
      this.$refs['balance-detail'].show();
    },
    setBalances: function (){
      if (this.$store.getters.currentAccount){
      this.balance_items = this.$store.state.balances[this.$store.getters.currentAccount]}
      else {this.balance_items = []}
    },
    // getSelectOptions: function (){
    //   let options = []
    //   Object.keys(this.$store.state.balances).forEach(element => options.push({value: element, text: element}))
    //   return options;
    // },
    // selectOption: function (value){
    //   this.$store.dispatch('setCurrentAccount', value)
    //   this.setBalances();
    // },
    listBalanceAccounts: function (){
      let options = []
      for (const [key] of Object.entries(this.$store.state.balances)){
        options.push(key)
      }
      return options;
    },
    selectAccount: function(e, value){
      this.$store.dispatch('setCurrentAccount', value);
      this.setBalances();
    },
    getPeriod: function (){
      if (this.$store.state.charges.length > 0){
        return this.$store.state.charges[0].period_id ?? ''
      } else {
        return ''
      }
    }
  },
  mounted() {
    if (!this.$store.getters.currentAccount){
      this.$store.dispatch('setCurrentAccount', Object.keys(this.$store.state.balances)[0]);
      this.selectAccount('e', Object.keys(this.$store.state.balances)[0])
    } else {this.selectAccount('e', this.$store.getters.currentAccount)}
    let accounts_list = [];
    if (Object.keys(this.$store.state.accounts).length > 0) {
      for (const [key] of Object.entries(this.$store.state.accounts)) {
        accounts_list.push(key)
        this.$store.dispatch('getBalances', key)
      }
    } else {
      this.$store.dispatch('getAccounts')
    }
  },
}
</script>

<style scoped>
.balance-col {
    -ms-flex: 0 0 200px;
    flex: 0 0 200px;
    padding-left: 1px;
    padding-right: 1px;
}
</style>